import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class QualificationsService {

  constructor(private _http: HttpClient) {
  }

  getCollegeSpecByCenterProfId(collegeId, professionId) {
    const filter = {collegeId: collegeId, centerProfessionId: professionId};
    return this._http.post<any[]>(`api/s/enrollApplication/getQualifications`, filter);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/services/qualifications.service.ts